import React, { Fragment, useState } from 'react';

import { useOrderContext } from 'hooks';
import { PaymentDetailsViewProps } from 'types';

import { SberQrHeader } from '../SberQrHeader';
import { SberQrInstructionWrapper } from '../SberQrInstructionWrapper';
import { SberQrRequisitesDetails } from '../SberQrRequisitesDetails';

export type MobileStep = 'save' | 'pay' | 'gallery';

export const SberQrPaymentDetails: React.FC<PaymentDetailsViewProps> = ({
  actions,
}) => {
  const { order, status } = useOrderContext();

  const confirmAction = actions[actions.length - 1];
  const [mobileStep, setMobileStep] = useState<MobileStep>('save');

  return (
    <Fragment>
      <SberQrHeader shopName={order.shop?.name ?? ''} status={status} />
      <div className="tw-flex tw-flex-col md:tw-flex-row tw-gap-4 md:tw-gap-12 md:tw-items-center tw-w-full">
        <SberQrInstructionWrapper
          mobileStep={mobileStep}
          className="md:tw-flex-1"
        />
        <SberQrRequisitesDetails
          confirmAction={confirmAction}
          onStepChange={setMobileStep}
          className="md:tw-flex-1"
        />
      </div>
    </Fragment>
  );
};
